import { FoodModifierGroupsComponent } from './../../../food/food-modifiers/food-modifier-groups/food-modifier-groups.component';
import { MessageService } from 'primeng/api';
import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MerchantStatusEnum } from 'app/models';
import { MerchantService } from 'app/services';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MerchantUserAndMerchantForConfirmedResponseDto } from './merchant-user-and-merchant-for-confirmed-response-dto';
import { debounceTime, Observable, of, switchMap } from 'rxjs';
@Component({
  selector: 'company-details',
  templateUrl: './company-details.component.html',
  styleUrls: [
    './company-details.component.scss',
    '../../../../../styles/default-material-theme.scss',
    '../../merchant-confirm-onboarding/merchant-confirm-onboarding.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CompanyDetailsComponent implements OnInit, AfterViewChecked {
  @Input() merchantUser!: MerchantUserAndMerchantForConfirmedResponseDto;
  @Input() merchantUserTemp!: MerchantUserAndMerchantForConfirmedResponseDto;

  @Output() loadingHandle = new EventEmitter<boolean>();
  @Output() openMerchantCompanyConfirmSideBar = new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();
  @Output() confirm = new EventEmitter<MerchantStatusEnum>();

  @Input() merchantStatusEnum = MerchantStatusEnum;

  public reviewProposalCheckBox: boolean = false;

  disabled = true;
  onSaving = false;
  isChanged = false;
  isEditing = false;

  zipCodeRegex = /^\d{4}$/; // PH Base
  phMobileNumberRegex = /^(?:\+639|09)\d{9}$/;

  companyDetailsFormGroup!: FormGroup;

  private shallowCopy!: MerchantUserAndMerchantForConfirmedResponseDto;
  public addresses: any[] = [];

  constructor(
    private messageService: MessageService,
    private merchantService: MerchantService
  ) {}

  ngOnInit(): void {
    this.shallowCopy = JSON.parse(JSON.stringify(this.merchantUser));
    this.companyDetailsFormGroup = new FormGroup({
      BusinessName: new FormControl('', Validators.required),
      BusinessAddress: new FormControl('', Validators.required),
      BusinessCity: new FormControl('', Validators.required),
      BusinessPostalCode: new FormControl('', [
        Validators.required,
        Validators.pattern(this.zipCodeRegex),
      ]),
      TradingName: new FormControl('', Validators.required),
      BusinessPhone: new FormControl('', [
        Validators.required,
        Validators.pattern(this.phMobileNumberRegex),
      ]),
      BusinessEmail: new FormControl('', Validators.email),
    });
    this.companyDetailsFormGroup.disable(); // disable by default
    this.companyDetailsFormGroup.setValue({
      BusinessName: this.merchantUser.BusinessName,
      BusinessAddress: this.merchantUser.BusinessAddress,
      BusinessCity: this.merchantUser.BusinessCity,
      BusinessPostalCode: this.merchantUser.BusinessPostalCode,
      TradingName: this.merchantUser.TradingName,
      BusinessPhone: this.merchantUser.BusinessPhone,
      BusinessEmail: this.merchantUser.BusinessEmail,
    });
    this.companyDetailsFormGroup.controls['BusinessAddress'].valueChanges.pipe(
        debounceTime(300),
        switchMap((query: string) => (query ? this.search(query) : of([])))
    ).subscribe((results: any) => {
        this.addresses = results;
    });
  }

  ngAfterViewChecked(): void {
    this.companyDetailsFormGroup.valueChanges.subscribe(
      (changes: MerchantUserAndMerchantForConfirmedResponseDto) => {
        this.isFieldMatches(changes);
      }
    );
  }
  public confirmMerchant(statusId: MerchantStatusEnum) {
    if (
      this.merchantUser.MerchantStatus ===
        this.merchantStatusEnum.DocumentUploaded &&
      !this.reviewProposalCheckBox
    ) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'You need to confirm that the data is correct.',
      });
      return;
    }

    const dto = {
      MerchantId: this.merchantUser.MerchantId,
      StatusId:
        this.merchantUser.MerchantStatus === MerchantStatusEnum.RejectedInitialOnboarding
          ? MerchantStatusEnum.ForApproval
          : statusId,
    };

    this.onSaving = true;

    this.merchantService
      .merchantStatusChange(dto, this.messageService)
      .then((data) => {
        if (!data.Success) {
          this.onSaving = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage,
          });
        } else {
          //getMerchantUserAndMerchantForConfirmed
        }
      })
      .catch((err) => {
        this.onSaving = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err,
        });
      });
  }

  onLoadingHandle() {
    this.loadingHandle.emit(!this.onSaving);
  }
  onOpenMechantCompanySideBar() {
    this.openMerchantCompanyConfirmSideBar.emit();
  }

  onEditInput() {
    this.disabled = !this.disabled;
    if (this.disabled) {
      this.companyDetailsFormGroup.disable();
      this.isEditing = false;
    } else {
      this.companyDetailsFormGroup.enable();
      this.isEditing = true;
    }
  }

  onEditSave() {
    this.onSaving = true;

    const dto: MerchantCompanyEditAdminRequestDto = {
      MerchantId: this.merchantUser.MerchantId,
      BusinessName: this.companyDetailsFormGroup.value.BusinessName,
      BusinessAddress: this.companyDetailsFormGroup.value.BusinessAddress,
      BusinessCity: this.companyDetailsFormGroup.value.BusinessCity,
      BusinessPostalCode: this.companyDetailsFormGroup.value.BusinessPostalCode,
      TradingName: this.companyDetailsFormGroup.value.TradingName,
      BusinessPhone: this.companyDetailsFormGroup.value.BusinessPhone,
      BusinessEmail: this.companyDetailsFormGroup.value.BusinessEmail,
    };

    if (
      !dto.BusinessName ||
      !dto.BusinessAddress ||
      !dto.TradingName ||
      !dto.BusinessCity ||
      !dto.BusinessPostalCode ||
      !dto.BusinessPhone ||
      !dto.BusinessEmail
    ) {
      this.messageService.add({
        severity: 'error',
        summary: 'Warning',
        detail: 'Please complete all required fields',
      });
      this.onSaving = false;
      return;
    }

    this.merchantService
      .merchantCompanyUpdate(dto, this.messageService)
      .then((data) => {
        if (!data) {
          this.onSaving = false;
          return;
        }

        if (!data.Success) {
          this.onSaving = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage,
          });
          return;
        }

        delete dto.MerchantId;
        this.companyDetailsFormGroup.setValue(dto);
        this.companyDetailsFormGroup.disable();
        this.onSaving = false;
        this.disabled = !this.disabled;
        this.isEditing = false;
      });
  }

  isFieldMatches(formData: MerchantUserAndMerchantForConfirmedResponseDto) {
    if (
      this.shallowCopy.BusinessAddress === formData.BusinessAddress &&
      this.shallowCopy.BusinessName === formData.BusinessName &&
      this.shallowCopy.BusinessCity === formData.BusinessCity &&
      this.shallowCopy.BusinessPostalCode === formData.BusinessPostalCode &&
      this.shallowCopy.TradingName === formData.TradingName &&
      this.shallowCopy.BusinessPhone === formData.BusinessPhone &&
      this.shallowCopy.BusinessEmail === formData.BusinessEmail
    ) {
      this.isChanged = false;
    } else {
      this.isChanged = true;
    }
  }

  onConfirmDetails() {
    this.confirm.emit(MerchantStatusEnum.ApprovedCompanyDetail);
  }

  //Google maps autocomplete
  public search(event: any) {
      return new Observable((observer) => {
          const query = event;
          const service = new google.maps.places.AutocompleteService();
          service.getPlacePredictions({ input: query, componentRestrictions: { country: 'PH' } }, (predictions, status) => {
              if (status === google.maps.places.PlacesServiceStatus.OK) {
                  observer.next(predictions ? predictions.map((prediction) => prediction.description) : []);
              } else {
                  observer.next([]);
              }
          });
      });
  }

  // public openMerchantCompanyConfirmSideBar() {
  //   this.showMerchantCompanyConfirmSideBar =
  //     !this.showMerchantCompanyConfirmSideBar;
  // }
  onCancel() {
    this.disabled = !this.disabled;
    this.isEditing = false;

    this.companyDetailsFormGroup.setValue({
      BusinessName: this.merchantUser.BusinessName,
      BusinessAddress: this.merchantUser.BusinessAddress,
      BusinessCity: this.merchantUser.BusinessCity,
      BusinessPostalCode: this.merchantUser.BusinessPostalCode,
      TradingName: this.merchantUser.TradingName,
      BusinessPhone: this.merchantUser.BusinessPhone,
      BusinessEmail: this.merchantUser.BusinessEmail,
    });

    this.companyDetailsFormGroup.disable();
  }
}

interface MerchantCompanyEditAdminRequestDto {
  MerchantId?: number;
  BusinessName: string;
  BusinessAddress: string;
  BusinessCity: string;
  BusinessPostalCode: number;
  TradingName: string;
  BusinessPhone: string;
  BusinessEmail: string;
}
